const links = [
  {
    id: "github",
    title: "GitHub",
    description: "Code, experiments, and open repositories.",
    href: "https://github.com/arifislam-me",
    label: "@arifislam-me",
    accent: "from-slate-300 via-slate-400 to-slate-500",
    icon: "github",
    iconType: "feather",
    color: "#000000",
    darkColor: "#ffffff",
    borderColor: "#000000",
    darkBorderColor: "#ffffff",
    background: "rgba(0, 0, 0, 0.1)",
    featured: true,
    footer: true,
  },
  {
    id: "linkedin",
    title: "LinkedIn",
    description: "Career timeline, network, and professional profile.",
    href: "https://www.linkedin.com/in/arifislam-me/",
    label: "arifislam-me",
    accent: "from-sky-300 via-blue-400 to-blue-600",
    icon: "linkedin",
    iconType: "feather",
    color: "#0a66c2",
    borderColor: "#0a66c2",
    background: "rgba(10, 102, 194, 0.1)",
    featured: true,
    footer: true,
  },
  {
    id: "email",
    title: "Email",
    description: "Best option for project discussions and direct contact.",
    href: "mailto:hello@arifislam.me",
    label: "hello@arifislam.me",
    accent: "from-rose-200 via-red-300 to-orange-300",
    icon: "mail",
    iconType: "feather",
    color: "#ef4444",
    borderColor: "#ef4444",
    background: "rgba(239, 68, 68, 0.1)",
    featured: true,
    footer: true,
  },
  {
    id: "facebook",
    title: "Facebook",
    description: "A lighter place to reach me and follow updates.",
    href: "https://www.facebook.com/arifislam.dnj",
    label: "arifislam.dnj",
    accent: "from-cyan-200 via-sky-300 to-blue-500",
    icon: "facebook",
    iconType: "feather",
    color: "#0688ff",
    borderColor: "#0688ff",
    background: "rgba(6, 136, 255, 0.1)",
    featured: false,
    footer: true,
  },
  {
    id: "discord",
    title: "Discord",
    description: "Quick async conversation for communities and side projects.",
    href: "https://discordapp.com/users/1122886182007738510",
    label: "arifislam.me",
    accent: "from-indigo-200 via-indigo-400 to-violet-500",
    icon: "ic:baseline-discord",
    iconType: "iconify",
    color: "#5865f2",
    borderColor: "#5865f2",
    background: "rgba(88, 101, 242, 0.1)",
    featured: false,
    footer: false,
  },
  {
    id: "instagram",
    title: "Instagram",
    description: "Stories, snapshots, and daily updates.",
    href: "https://www.instagram.com/arifislam.me",
    label: "arifislam.me",
    accent: "from-orange-200 via-pink-300 to-rose-400",
    icon: "instagram",
    iconType: "feather",
    color: "#F77737",
    borderColor: "#F77737",
    background: "rgba(247, 119, 55, 0.12)",
    featured: false,
    footer: false,
  },
  {
    id: "wordpress",
    title: "WordPress",
    description: "Open-source profile and community contributions.",
    href: "https://profiles.wordpress.org/arifislamdev/",
    label: "arifislamdev",
    accent: "from-sky-200 via-sky-400 to-blue-600",
    icon: "ic:baseline-wordpress",
    iconType: "iconify",
    color: "#21759b",
    borderColor: "#21759b",
    background: "rgba(33, 117, 155, 0.12)",
    featured: false,
    footer: false,
  },
  {
    id: "codeforces",
    title: "Codeforces",
    description: "Competitive programming profile and contests.",
    href: "https://codeforces.com/profile/md_arif_islam",
    label: "md_arif_islam",
    accent: "from-red-200 via-rose-300 to-rose-500",
    icon: "mdi:trophy-outline",
    iconType: "iconify",
    color: "#ef4444",
    borderColor: "#ef4444",
    background: "rgba(239, 68, 68, 0.12)",
    featured: false,
    footer: false,
  },
  {
    id: "leetcode",
    title: "LeetCode",
    description: "Practice problems, rankings, and coding streaks.",
    href: "https://leetcode.com/u/arifislam_me/",
    label: "arifislam_me",
    accent: "from-amber-200 via-orange-300 to-amber-500",
    icon: "simple-icons:leetcode",
    iconType: "iconify",
    color: "#f59e0b",
    borderColor: "#f59e0b",
    background: "rgba(245, 158, 11, 0.12)",
    featured: false,
    footer: false,
  },
  {
    id: "twitter",
    title: "X / Twitter",
    description: "Thoughts, links, and short-form updates.",
    href: "https://x.com/arifislam_me",
    label: "@arifislam_me",
    accent: "from-slate-200 via-slate-400 to-slate-700",
    icon: "twitter",
    iconType: "feather",
    color: "#00acee",
    borderColor: "#00acee",
    background: "rgba(0, 172, 238, 0.1)",
    featured: false,
    footer: true,
  },
];

export const featuredLinks = links.filter((link) => link.featured);
export const footerLinks = links.filter((link) => link.footer);

export default links;
